"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_router_1 = require("react-router");
const List_1 = __importDefault(require("@mui/material/List"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const PersonOutlineRounded_1 = __importDefault(require("@mui/icons-material/PersonOutlineRounded"));
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const Helmet_1 = __importDefault(require("components/Helmet"));
const Investments_1 = __importDefault(require("containers/Settings/ChildPages/Investments"));
const General_1 = __importDefault(require("containers/Settings/ChildPages/General"));
const Appearance_1 = __importDefault(require("containers/Settings/ChildPages/Appearance"));
const Budgets_1 = __importDefault(require("containers/Settings/ChildPages/Budgets"));
const Accounts_1 = __importDefault(require("containers/Settings/ChildPages/Accounts"));
const Datasets_1 = __importDefault(require("containers/Settings/ChildPages/Datasets"));
const RulesQuicken_1 = __importDefault(require("containers/Settings/ChildPages/RulesQuicken"));
const MemorizedPayee_1 = __importDefault(require("containers/Settings/ChildPages/MemorizedPayee"));
const CategoriesTagsSettings_1 = __importDefault(require("containers/Settings/ChildPages/CategoriesTagsSettings"));
const AccountBalanceRounded_1 = __importDefault(require("@mui/icons-material/AccountBalanceRounded"));
const AssignmentIndRounded_1 = __importDefault(require("@mui/icons-material/AssignmentIndRounded"));
const TurnedInNotRounded_1 = __importDefault(require("@mui/icons-material/TurnedInNotRounded"));
const AttachMoneyRounded_1 = __importDefault(require("@mui/icons-material/AttachMoneyRounded"));
const DarkModeOutlined_1 = __importDefault(require("@mui/icons-material/DarkModeOutlined"));
const investments_quicken_inline_svg_1 = __importDefault(require("assets/nav-menu/investments.quicken.inline.svg"));
const CompareArrowsRounded_1 = __importDefault(require("@mui/icons-material/CompareArrowsRounded"));
const budgets_inline_svg_1 = __importDefault(require("assets/nav-menu/budgets.inline.svg"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const settingsTabs = {
    general: {
        name: 'General',
        icon: () => <PersonOutlineRounded_1.default />,
        allow: 'profileEnabled',
        page: () => <General_1.default />,
    },
    appearance: {
        name: 'Appearance',
        icon: () => <DarkModeOutlined_1.default />,
        allow: 'appearanceEnabled',
        page: () => <Appearance_1.default />,
    },
    accounts: {
        name: 'Accounts',
        icon: () => <AccountBalanceRounded_1.default />,
        allow: 'accountEnabled',
        page: () => <Accounts_1.default />,
    },
    categoriesTags: {
        name: 'Categories & Tags',
        icon: () => <TurnedInNotRounded_1.default />,
        allow: 'categoriesTagsEnabled',
        page: () => <CategoriesTagsSettings_1.default />,
    },
    finances: {
        name: 'Finances',
        icon: () => <AttachMoneyRounded_1.default />,
        allow: 'financesEnabled',
        page: () => <Datasets_1.default />,
    },
    budgets: {
        name: 'Budgets',
        icon: () => <budgets_inline_svg_1.default width="32" height="32" fill="currentColor"/>,
        allow: 'budgetsManagement',
        page: () => <Budgets_1.default />,
    },
    'rename-rules': {
        name: 'Renaming Rules',
        icon: () => <CompareArrowsRounded_1.default />,
        allow: 'renameRulesSettingsEnabled',
        page: () => <RulesQuicken_1.default />,
    },
    'memorized-payee': {
        name: 'Memorized Payee',
        icon: () => <AssignmentIndRounded_1.default />,
        allow: 'memorizedPayeeEnabled',
        page: () => <MemorizedPayee_1.default />,
    },
    investments: {
        name: 'Investments',
        icon: () => <investments_quicken_inline_svg_1.default width="20" height="20" fill="currentColor"/>,
        allow: 'investmentPreference',
        page: () => <Investments_1.default />,
    },
};
const Settings = () => {
    const { classes } = useStyles();
    const { settingSelected } = (0, react_router_1.useParams)();
    const [openTab, setOpenTab] = React.useState(settingSelected || 'general');
    const navigate = (0, react_router_1.useNavigate)();
    const featureFlags = (0, react_redux_1.useSelector)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const investmentAccounts = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getInvestmentAccounts);
    if (isEntitySharedUser) {
        const tabsHidedForEntitySharedUser = ['accounts', 'categoriesTags', 'rename-rules', 'memorized-payee'];
        tabsHidedForEntitySharedUser.forEach((settingsTab) => {
            delete settingsTabs[settingsTab];
        });
        if (!investmentAccounts || investmentAccounts.size === 0) {
            delete settingsTabs.investments;
        }
    }
    const flags = {
        categoriesTagsEnabled: featureFlags.get('categoryTagsManagement'),
        profileEnabled: true,
        appearanceEnabled: true,
        accountEnabled: featureFlags.get('accountsManagement'),
        financesEnabled: featureFlags.get('finances'),
        recurringManagement: featureFlags.get('recurringManagement'),
        budgetsManagement: featureFlags.get('budgetsManagement'),
        renameRulesSettingsEnabled: featureFlags.get('showRenameRulesSettings'),
        memorizedPayeeEnabled: featureFlags.get('showMemorizedTransactionsSettings'),
        rulesEnabled: featureFlags.get('rules'),
        investmentPreference: featureFlags.get('investmentPreference'),
    };
    const settingToShow = settingsTabs === null || settingsTabs === void 0 ? void 0 : settingsTabs[openTab];
    const changeTab = (tab) => {
        setOpenTab(tab);
        navigate(`/settings/${encodeURIComponent(tab)}`, { replace: true });
    };
    return (<div className={classes.root}>
      <Helmet_1.default title={`Settings: ${settingToShow.name}`}/>
      <AppBar_1.default position="sticky" color="inherit" elevation={0} className={classes.appBar}>
        <Toolbar_1.default classes={{ root: classes.toolbar }}>
          <ListItemText_1.default primary="Settings" primaryTypographyProps={{ variant: 'h6' }} style={{ whiteSpace: 'nowrap' }}/>
        </Toolbar_1.default>
      </AppBar_1.default>
      <div className={classes.content}>
        <Grid_1.default container style={{ overflow: 'hidden' }}>
          <Grid_1.default item sm={12} className={classes.tabs}>
            <Slide_1.default direction="right" in mountOnEnter unmountOnExit>
              <div className={classes.leftContent}>
                <List_1.default component="nav">
                  {Object.keys(settingsTabs).map((settingKey) => {
            const setting = settingsTabs[settingKey];
            return flags[setting.allow] && (<ListItem_1.default key={settingKey} id={`${settingKey === null || settingKey === void 0 ? void 0 : settingKey.toLowerCase()}-button`} button selected={openTab === settingKey} onClick={() => changeTab(settingKey)} classes={{ selected: classes.selectedList, root: classes.onHoverActive }}>
                          <ListItemIcon_1.default>{setting.icon()}</ListItemIcon_1.default>
                          <ListItemText_1.default primary={setting.name}/>
                        </ListItem_1.default>);
        })}
                </List_1.default>
              </div>
            </Slide_1.default>
          </Grid_1.default>
          <Grid_1.default item sm={12}>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Slide_1.default direction="left" in mountOnEnter unmountOnExit>
              <div className={classes.rightContent}>
                {flags[settingToShow === null || settingToShow === void 0 ? void 0 : settingToShow.allow] && (settingToShow === null || settingToShow === void 0 ? void 0 : settingToShow.page())}
              </div>
            </Slide_1.default>
          </Grid_1.default>
        </Grid_1.default>
      </div>
    </div>);
};
exports.default = Settings;
